<template>
  <a :disabled="!canSendVerificationCode"
     :class="{'is-loading': isCodeLoading}"
     class="button is-primary small"
     @click="getVerificationCode()">
    {{ btnVerificationCodeText }}
    <span v-if="isShowTimer"> ({{ timer }}s)</span>
  </a>
</template>

<script>

import utils from '../../source/utils';
const ONE_MINUTE = 60;

export default {
  props: {
    phoneNumber: String
  },
  data() {
    return {
      secondsTimer: null,
      isCodeLoading: false,
      isCodeSent: false,
      isShowTimer: false,
      timer: ONE_MINUTE
    };
  },
  computed: {
    labels() {
      return {
        getCode: this.$gettext('Get code'),
        resendCode: this.$gettext('Resend code')
      };
    },
    btnVerificationCodeText() {
      return this.isCodeSent ? this.labels.resendCode : this.labels.getCode;
    },
    canSendVerificationCode() {
      return this.phoneNumber && utils.isValidPhone(this.phoneNumber) && !this.isShowTimer && !this.isCodeLoading;
    }
  },
  methods: {
    toogleTimer() {
      this.isShowTimer = !this.isShowTimer;
    },
    toogleCodeLoading() {
      this.isCodeLoading = !this.isCodeLoading;
    },
    getVerificationCode() {
      this.toogleCodeLoading();
      this.$store
        .dispatch('sendVerificationCodeAction', {phone: this.phoneNumber})
        .then(() => {
          this.isCodeSent = true;
          this.countdown();
        })
        .finally(() => this.toogleCodeLoading());
    },
    countdown() {
      this.toogleTimer();
      this.secondsTimer = setInterval(() => {
        this.timer -= 1;

        if (this.timer === 1) {
          this.resetTimer();
        }
      }, 1000);
    },
    resetTimer() {
      clearInterval(this.secondsTimer);
      this.toogleTimer();
      this.timer = ONE_MINUTE;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~VariablesStyles';
.button {
  position: absolute;
  top: 9px;
  right: 10px;

  span {
    width: 30px;
    padding-left: 5px;
  }
}
@media (max-width: $desktop) {
  .button {
    width: auto;
  }
}
</style>
